import React from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react';

import ContentView from '../components/ui-controls/layout/ContentView';
import Text from '../components/ui-controls/Text';
import {AppRoute} from '../models/AppRoute';
import {RouteNavigatorScreenProps} from '../models/navigationTypes';
import {useStores} from '../stores/use-stores';
import theme from '../style/theme';

export default observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.CART_ORDER_CONFIRMATION>) => {
    const {cartStore} = useStores();

    const endPostOrderFlow = () => {
      cartStore.fullyReloadOrderFromMFL();
      navigation.navigate(AppRoute.SHOP);
    };

    const getTimeWindow = () => {
      let [from, to]: [Date | string, Date | string] = [
        new Date(cartStore.selectedSlot?.dropOffWindow[0]),
        new Date(cartStore.selectedSlot?.dropOffWindow[1]),
      ];
      const day = from.toLocaleString('en-AU', {
        month: 'short',
        day: 'numeric',
      });
      from = from.toLocaleString('en-AU', {timeStyle: 'short'});
      to = to.toLocaleString('en-AU', {timeStyle: 'short'});

      return `${day}, ${from} - ${to}`;
    };

    return (
      <ContentView testID="order-confirmation-screen">
        <Text style={styles.heading}>
          Thanks for your order, here are your confirmation details.
        </Text>
        <Text style={styles.infoLine}>Order Number: {cartStore.currentOrder?.order_number}</Text>
        <Text style={styles.infoLine}>
          {cartStore.isDelivery ? 'Delivery' : 'Pick Up'} Time: {getTimeWindow()}
        </Text>
        <View style={styles.emphasisBorder}>
          {cartStore.isDelivery ? (
            <Text style={styles.infoLine}>
              Please ensure the nominated adult (18+) accepting the order has a valid ID for
              verification by our driver.
            </Text>
          ) : null}
          {cartStore.isPickup ? (
            <Text style={[styles.infoLine, styles.centered]}>
              Please ensure the nominated adult (18+) picking up the order has a valid ID and the
              credit card used for the order for verification by our staff.
            </Text>
          ) : null}
        </View>
        <Text style={styles.heading}>Enjoy your drinks!</Text>
        <Pressable onPress={endPostOrderFlow} style={styles.button}>
          <Text style={styles.button.text}>OK</Text>
        </Pressable>
      </ContentView>
    );
  },
);

const styles = StyleSheet.create({
  centered: {
    textAlign: 'center',
  },
  heading: {
    fontSize: 24,
    fontWeight: '600',
    color: theme.colour.text.heading.primary,
    textAlign: 'center',
    marginBottom: 24,
  },
  infoLine: {
    fontSize: 16,
    fontWeight: '500' as const,
    color: theme.colour.text.content.primary,
    marginBottom: 16,
  },
  button: {
    backgroundColor: theme.colour.background.button.primary,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600' as const,
      fontSize: 16,
    },
  },
  emphasisBorder: {
    borderWidth: 0.5,
    borderColor: theme.colour.border.general.primary,
    borderRadius: 4,
    paddingTop: 16,
    paddingHorizontal: 16,
    marginBottom: 16,
  },
});
